import { render } from "./AssignedToMe.vue?vue&type=template&id=40d6371c&scoped=true"
import script from "./AssignedToMe.vue?vue&type=script&lang=js"
export * from "./AssignedToMe.vue?vue&type=script&lang=js"

import "./AssignedToMe.vue?vue&type=style&index=0&id=40d6371c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_typescript@5.4.2__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d6371c"]])

export default __exports__